import React from 'react';
import { ClientContext } from 'containers/client/ClientProvider';
import { Map } from 'immutable';

export const UserTranslation = () => {
  const client = React.useContext(ClientContext);
  const api_key = process.env.REACT_APP_WEGLOT_API_KEY;
  const OCADO_PORTAL_LANGUAGES =
    client &&
    Map.isMap(client.properties) &&
    client.properties.get('OCADO_PORTAL_LANGUAGES');

  React.useEffect(() => {
    let script;
    let loadWeglotScript = async () =>
      new Promise((resolve, reject) => {
        script = document.createElement('script');
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        const ref = document.getElementsByTagName('script')[0];
        ref
          ? ref.parentNode.insertBefore(script, ref)
          : document.head && document.head.appendChild(script);

        script.src = 'https://cdn.weglot.com/weglot.min.js';
      });

    const weglotContainer = document.querySelector('.weglot-container');

    if (OCADO_PORTAL_LANGUAGES) {
      if (OCADO_PORTAL_LANGUAGES.length && window.Weglot == null) {
        const defaultLanguage = 'en';
        if (OCADO_PORTAL_LANGUAGES === defaultLanguage) {
          return;
        }
        loadWeglotScript()
          .then(() => {
            window.Weglot &&
              window.Weglot.initialize({
                api_key,
                cache: true,
                whitelist: [
                  {
                    value: '[data-translate="true"]',
                  },
                ],
                excluded_blocks: [
                  {
                    value: '[data-translate="false"]',
                  },
                ],
              });
          })
          .then(() => {
            window.Weglot.on('switchersReady', () => {
              let languageList = OCADO_PORTAL_LANGUAGES.split(/\s*,\s*/);
              let langOptions = document.querySelectorAll(
                '.weglot-container li'
              );
              if (!languageList.includes(defaultLanguage)) {
                languageList.push(defaultLanguage);
              }
              for (let i = 0; i < langOptions.length; i++) {
                if (languageList.includes(langOptions[i].dataset.l)) return;

                langOptions[i].style.display = 'none';
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        weglotContainer && (weglotContainer.style.display = 'block');
      }
    } else {
      window.Weglot && window.Weglot.switchTo('en');
      weglotContainer && (weglotContainer.style.display = 'none');
    }

    return () => {
      if (script != null) document.head.removeChild(script);
    };
  }, [OCADO_PORTAL_LANGUAGES]);

  return null;
};



// WEBPACK FOOTER //
// ./src/pages/__components__/UserTranslation.js